module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB4001-139463655285eabf123b1dd4438152fb.png";